import { render, staticRenderFns } from "./EmployeeCreate.vue?vue&type=template&id=9a201fa8&scoped=true"
import script from "./EmployeeCreate.vue?vue&type=script&lang=js"
export * from "./EmployeeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a201fa8",
  null
  
)

export default component.exports